import { Heading, Text, SimpleGrid, Box, Flex, Select } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import ProjectCard from "~/components/ProjectCard";
import { ProjectDocument, SupportedChains } from "~/core/types";
import { SUPPORTED_CHAINS } from "~/core/constants";
import { adminDb } from "~/core/initFirebaseAdmin";
import firestoreToJson from "~/core/firestoreToJson";
import { tsOrStringToDate } from "~/core/helpers";

export default function Explore({ projects }: { projects: ProjectDocument[] }) {
  const [chain, setChain] = useState<keyof typeof SUPPORTED_CHAINS | "all">(
    "all"
  );
  const [filteredProjects, setFilteredProjects] = useState<ProjectDocument[]>(
    []
  );

  useEffect(() => {
    if (chain === "all") {
      setFilteredProjects(projects);
    } else {
      setFilteredProjects(
        projects.filter((project) => project.chain === chain)
      );
    }
  }, [projects, chain]);

  return (
    <Box marginX="auto" p={6} maxW={1200}>
      <Flex
        alignItems={{ base: "flex-start", sm: "center" }}
        direction={{ base: "column", sm: "row" }}
      >
        <Heading
          opacity={0.8}
          mb={{ base: 4, sm: 0 }}
          width={{ base: "100%", sm: "auto" }}
        >
          Public Campaigns
        </Heading>

        <Box display={{ base: "none", sm: "initial" }} flex={1}></Box>

        <Box width={{ base: "100%", sm: "auto" }}>
          <Select
            placeholder="Select chain"
            onChange={(e) => {
              console.log("event", e.target.value);
              setChain((e.target.value || "all") as SupportedChains | "all");
            }}
          >
            <option value="all">All</option>
            {(Object.keys(SUPPORTED_CHAINS) as SupportedChains[]).map((key) => (
              <option key={key} value={key}>
                {SUPPORTED_CHAINS[key].name}
              </option>
            ))}
          </Select>
        </Box>
      </Flex>
      <SimpleGrid minChildWidth="250px" spacing={8} my={8}>
        {filteredProjects.length ? (
          filteredProjects.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))
        ) : (
          <Text>No campaigns yet</Text>
        )}
      </SimpleGrid>
    </Box>
  );
}

export async function getServerSideProps() {
  const querySnapshot = await adminDb
    .collection("projects")
    .where("isPrivate", "==", false)
    .where("entryCount", ">=", 5)
    .orderBy("entryCount", "desc")
    .orderBy("createdAt", "desc")
    .limit(200)
    .get();

  const projects = querySnapshot.docs.map(firestoreToJson);
  const active: ProjectDocument[] = [];
  const expired: ProjectDocument[] = [];
  projects.forEach((project) => {
    const projectDoc = project as ProjectDocument;
    if (!projectDoc.signupAccess) {
      active.push(projectDoc);
    } else if (!projectDoc.signupAccess.endDate) {
      active.push(projectDoc);
    } else if (
      new Date().getTime() <
      tsOrStringToDate(projectDoc.signupAccess.endDate).getTime()
    ) {
      active.push(projectDoc);
    } else {
      expired.push(projectDoc);
    }
  });
  const combined = active.concat(expired);

  return { props: { projects: combined } };
}
